import { updateCurrentUser } from '@mews-commander/core';
import { useRepositoryMutation } from '@mews-commander/data-access';

export const useEnablePinMutation = () =>
    useRepositoryMutation('users', 'setUnlockPin', {
        onSuccess: () => {
            updateCurrentUser({ hasUnlockPin: true });
        },
    });
